import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';

import styles from './styles/fraudulent-order-modal.scss';

const causes = {
    INCOGNITO_MODE_NOT_ALLOWED: 'incognito_mode_not_allowed',
    INVALID_ORDER: 'invalid_order_not_to_process',
};

const OrderErrorModal = ({
    onHide,
    show,
    orderError,
    order,
    ...props
}) => (
    <Modal
        show={show}
        onHide={onHide}
        {...props}
        aria-labelledby="contained-modal-title-lg"
    >
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
                <FormattedMessage id="error-title" defaultMessage="Error" />
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
            {orderError && orderError.cause === causes.INCOGNITO_MODE_NOT_ALLOWED && <span>{orderError.error}</span>}
            {orderError && orderError.cause === causes.INVALID_ORDER && (
                <section>
                    <FormattedMessage id="invalid-order-title" defaultMessage="There is a problem processing the order" />
                    <div className={styles.headerInfo}>
                        <FormattedMessage id="invalid-order-contact-info" defaultMessage="To help you complete your order please send us a message to " />
                        <a href="mailto:info@katapulk.com">info@katapulk.com</a>
                        <FormattedMessage id="invalid-order-contact-info2" defaultMessage=" including:" />
                    </div>
                    <div className={styles.bodyInfo}>
                        <FormattedMessage id="invalid-order-first-and-last-name" defaultMessage="First and Last Name: " />
                    </div>
                    <div>
                        <FormattedMessage id="invalid-order-phone-number" defaultMessage="Phone number: " />
                    </div>
                    {order && order.number && (
                        <div>
                            <FormattedMessage id="invalid-order-order-number" defaultMessage="Order Number: " />
                            <span className={styles.caseNumber}>{order.number}</span>
                        </div>
                    )}
                    {orderError && orderError.case_number && (
                        <div>
                            <FormattedMessage id="invalid-order-case-number" defaultMessage="Case Number: " />
                            <span className={styles.caseNumber}>{orderError.case_number}</span>
                        </div>
                    )}
                </section>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={() => onHide()}>
                <FormattedMessage id="payment-modal-extra-time-button" defaultMessage="Close" />
            </Button>
        </Modal.Footer>
    </Modal>
);

export default injectIntl(OrderErrorModal);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/modals/fraudulent-order-modal.jsx
 **/